import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/pythonleftimg.png";
import rightimgs from "../../../assets/pythonrightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/python-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/python-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/python-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/python-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/python-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/python-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/python-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/python-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/python-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/pythonFun-img1.png";
import FunactivitiesImg2 from "../../../assets/pythonFun-img2.png";
import FunactivitiesImg3 from "../../../assets/pythonFun-img3.png";
import FunactivitiesImg4 from "../../../assets/pythonFun-img4.png";
import FunactivitiesImg5 from "../../../assets/pythonFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "06",
      description: "Fundamentals of Python: Learn Python basics including variables, data types, conditions, and operators for a solid programming foundation.",
    },
   {
      title: "Module 2",
      activities: "11",
      classes: "05",
      description: "Python Logics: Understand loops, arrays, and functions to build programming logic and reusable code.",
    },
   {
      title: "Module 3",
      activities: "11",
      classes: "05",
      description: "Object-Oriented Programming: Learn about classes, objects, inheritance, polymorphism, encapsulation, and file handling in Python.",
    },
   
    
  ];

  

  const benefitsData = [
      {
        title: "Master Python Fundamentals",
        description: "Learn variables, data types, conditions, loops, and functions.",
        icon: "Polymath-images/python-benefit-img1.png", //ji
      },
      {
        title: "Master Logic Building",
        description: "Develop core skills in arrays, OOP, and file handling.",
        icon: "Polymath-images/python-benefit-img2.png",
      },
      {
        title: "Apply Problem-Solving Techniques",
        description: "Tackle coding challenges using logic and creativity.",
        icon: "Polymath-images/python-benefit-img3.png",
      },
      {
        title: "Think Computationally",
        description: "Strengthen analytical thinking with text-based coding.",
        icon: "Polymath-images/python-benefit-img4.png",
      },
      {
        title: "Sharpen Math Skills ",
        description: "Use Python to apply arithmetic, logic, and comparisons.",
        icon: "Polymath-images/python-benefit-img5.png",
      },
      {
        title: "Strengthen Digital Literacy",
        description: "Understand core programming tools and digital structures.",
        icon: "Polymath-images/python-benefit-img6.png",
      },
      {
        title: "Develop Career-Ready Skills",
        description: "Prepare for future tech careers with in-demand coding knowledge.",
        icon: "Polymath-images/python-benefit-img7.png",
      },
      {
        title: "Unlock Opportunities",
        description: "Open doors to tech futures.",
        icon: "Polymath-images/python-benefit-img8.png",
      },
      {
        title: "Understand Real-World Problems",
        description: "Explore how Python solves everyday tech problems.",
        icon: "Polymath-images/python-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Drawing Shapes",
          image: "Polymath-images/pythonFun-img1.png",
        },
        {
          title: "Calculator",
          image: "Polymath-images/pythonFun-img2.png",
        },
        {
          title: "Phone Book",
          image: "Polymath-images/pythonFun-img3.png",
        },
        {
          title: "Dice Roll Simulator",
          image: "Polymath-images/pythonFun-img4.png",
        },
        {
          title: "File Handling",
          image: "Polymath-images/pythonFun-img5.png",
        },
      ];
   
const Python = () => {
  const Scratchpage = heroContent.pythonsection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={'Polymath-images/pythonleftimg.png'}
      rightImg={'Polymath-images/pythonrightimg.png'}
      titlePart1="Python Programming"
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online Python programming course, a text-based programming language. The online coding classes’ offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Beginner Level Course"
              modules={beginnerModules}
            />
           
       <Benefits
        title="How Students Can Benefit From Python Programming"
        benefitsData={benefitsData} 
      />
       <FunActivities
              mainTitle="Learn Python Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Python